import { getCookieValue } from './getCookieValue'

export const getVisibilityStatusFromCookie = (): boolean => {
  return getCookieValue(document.cookie, '17696_promotion_bar_hidden') === 'true'
}
